module.exports = __webpack_public_path__ + "static/media/btn_excel.cd8ba185.svg";